




















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import Map from '@/components/parts/Map.vue';
import CharacterIcon from '@/components/parts/CharacterIcon.vue';
import StatusParametersPanel from '@/components/parts/StatusParameters.vue';
import ChatMessagePanel from '@/components/parts/ChatMessagePanel.vue';
import MapLogList from '@/components/parts/MapLogList.vue';
import TownList from '@/components/parts/TownList.vue';
import SimpleCharacterList from '@/components/parts/SimpleCharacterList.vue';
import MiniCharacterList from '@/components/parts/MiniCharacterList.vue';
import GameDateTimePicker from '@/components/parts/GameDateTimePicker.vue';
import SoldierTypePicker from '@/components/parts/SoldierTypePicker.vue';
import UnitPicker from '@/components/parts/UnitPicker.vue';
import CharacterIconPicker from '@/components/parts/CharacterIconPicker.vue';
import BattleLogView from '@/components/parts/BattleLogView.vue';
import ThreadBbs from '@/components/parts/ThreadBbs.vue';
import IssueBbs from '@/components/parts/IssueBbs.vue';
import CommandListView from '@/components/parts/status/CommandList.vue';
import AllianceView from '@/components/parts/status/AllianceView.vue';
import WarView from '@/components/parts/status/WarView.vue';
import TownWarView from '@/components/parts/status/TownWarView.vue';
import UnitListView from '@/components/parts/status/UnitView.vue';
import CountryPolicyList from '@/components/parts/CountryPolicyList.vue';
import FormationList from '@/components/parts/FormationList.vue';
import SkillList from '@/components/parts/SkillList.vue';
import QueueList from '@/components/parts/QueueList.vue';
import TownSubBuildingList from '@/components/parts/TownSubBuildingList.vue';
import CharacterItemList from '@/components/parts/CharacterItemList.vue';
import GenerateItemTypePicker from '@/components/parts/GenerateItemTypePicker.vue';
import KmyChatTagText from '@/components/parts/KmyChatTagText.vue';
import * as api from '@/api/api';
import * as def from '@/common/definitions';
import StatusModel from '@/models/status/statusmodel';
import { StatusParameter } from '@/models/status/statusparameter';
import ChatMessageContainer, { IChatMessageContainer } from '@/models/status/chatmessagecontainer';
import Enumerable from 'linq';
import EventObject from '@/models/common/EventObject';

@Component({
  components: {
    Map,
    CharacterIcon,
    StatusParametersPanel,
    ChatMessagePanel,
    MapLogList,
    TownList,
    SimpleCharacterList,
    MiniCharacterList,
    GameDateTimePicker,
    UnitPicker,
    CharacterIconPicker,
    SoldierTypePicker,
    BattleLogView,
    ThreadBbs,
    IssueBbs,
    CommandListView,
    AllianceView,
    WarView,
    TownWarView,
    UnitListView,
    KmyChatTagText,
    CountryPolicyList,
    FormationList,
    CharacterItemList,
    GenerateItemTypePicker,
    SkillList,
    QueueList,
    TownSubBuildingList,
  },
})
export default class StatusPage extends Vue {
  public model: StatusModel = new StatusModel();
  public isApp: boolean = false;
  public isOpenRightSidePopupMenu: boolean = false;
  public isOpenSoliderDropdown: boolean = false;
  public mapMode: number = 0;
  public selectedInformationTab: number = 0;
  public selectedActionTab: number = 0;
  public selectedActionTabSubPanel: number = 0;
  public selectedChatCategory: number = 0;
  public selectedSoldierType: def.SoldierType = Enumerable.from(def.SOLDIER_TYPES).first((t) => t.id === 500);
  public selectedSoldierNumberType: number = 0;
  public isOpenSoldierDialog: boolean = false;
  public isOpenTownCharactersDialog: boolean = false;
  public isOpenTownDefendersDialog: boolean = false;
  public isOpenCountryCharactersDialog: boolean = false;
  public isOpenAllianceDialog: boolean = false;
  public isOpenWarDialog: boolean = false;
  public isOpenUnitsDialog: boolean = false;
  public isOpenBattleLogDialog: boolean = false;
  public isLoadingBattleLog: boolean = false;
  public isOpenPromotionDialog: boolean = false;
  public isOpenCommandersDialog: boolean = false;
  public isOpenRiceDialog: boolean = false;
  public isOpenSafeDialog: boolean = false;
  public isOpenSafeOutDialog: boolean = false;
  public isOpenTownWarDialog: boolean = false;
  public isOpenOppositionCharactersDialog: boolean = false;
  public isOpenSecretaryDialog: boolean = false;
  public isOpenSecretaryTownDialog: boolean = false;
  public isOpenAddSecretaryDialog: boolean = false;
  public isOpenRemoveSecretaryDialog: boolean = false;
  public isOpenCharacterIconPickerDialog: boolean = false;
  public isOpenPoliciesDialog: boolean = false;
  public isOpenFormationDialog: boolean = false;
  public isOpenFormationAddDialog: boolean = false;
  public isOpenFormationChangeDialog: boolean = false;
  public isOpenCharacterItemDialog: boolean = false;
  public isOpenCharacterItemBuyDialog: boolean = false;
  public isOpenCharacterItemSellDialog: boolean = false;
  public isOpenCharacterItemHandOverDialog: boolean = false;
  public isOpenCharacterItemUseDialog: boolean = false;
  public isOpenSkillDialog: boolean = false;
  public isOpenGenerateItemUseDialog: boolean = false;
  public isOpenCommandCommentDialog: boolean = false;
  public isOpenBuildTownSubBuildingDialog: boolean = false;
  public isOpenRemoveTownSubBuildingDialog: boolean = false;
  public isOpenMapDialog: boolean = false;
  public isOpenWelcomeDialog: boolean = false;
  public isOpenCustomizeFlyingColumnDialog: boolean = false;
  public isOpenRemoveFlyingColumnDialog: boolean = false;
  public isOpenQueueDialog: boolean = false;
  public isOpenCreateTownDialog: boolean = false;
  public isOpenCommanderTargetCharacterDialog: boolean = false;
  public isOpenImage: boolean = false;
  public isYesno: boolean = false;
  public yesnoMessage: string = '';
  public selectedWarStatus: number = 0;
  public selectedRiceStatus: number = 0;
  public selectedDirection: number = 0;
  public selectedTownType: number = 0;
  public selectedSecretaryType: number = 0;
  public soldierMode: number = 0;
  public isOpenCharacterHelpPopup: boolean = false;
  public isMoveIfFailed: boolean = false;

  public soldierNumber: number = 1;
  public battleLogId: number = 0;
  public mapShowType: number = 0;
  public mapDialogMode: number = 0;
  public mapDialogSelectedTown: api.Town = new api.Town(-1);
  public promotionTarget: api.Character = new api.Character(-1);
  public promotionMessage: string = '';
  public targetSecretary: api.Character = new api.Character(-1);
  public targetCharacter: api.Character = new api.Character(0);
  public targetUnit: api.Unit = new api.Unit(-1);
  public flyingColumnAction: number = 0;
  public flyingColumnSoldierType: number = 0;
  public newCountryCommandersMessage: string = '';
  public newCountrySolicitationMessage: string = '';
  public newCountryUnifiedMessage: string = '';
  public newPrivateMessage: string = '';
  public newCountryCommanderSubject: number = 1;
  public newCountryCommanderSubject2: number = 5;
  public newCountryCommanderSubjectData: number = 0;
  public newCountryCommanderSubjectData2: number = 0;
  public newCountryCommanderSubject2Data: number = 0;
  public characterFilterMode: number = 0;
  public commanderPrivateMessage: string = '';
  public newMuteKeywords: string = '';
  public payRiceOrMoney: number = -1;
  public paySafeMoney: number = def.PAY_SAFE_MAX;
  public paySafeTarget: api.Character = new api.Character(-1);
  public canTownWar: boolean = false;
  public selectedIconAtPrivateConfig: api.CharacterIcon = new api.CharacterIcon(-1);
  public newIcon: api.CharacterIcon = new api.CharacterIcon(-1, 0, false, 1, '0.gif');
  public isShowIconOperations = false;
  public selectedCountryPolicyType: def.CountryPolicyType = new def.CountryPolicyType(-1);
  public selectedFormationType: def.FormationType = new def.FormationType(-1);
  public selectedCharacterItemType: { type: def.CharacterItemType, id: number } =
    { type: new def.CharacterItemType(-1), id: -1 };
  public selectedGenerateItemType: def.CharacterItemType = new def.CharacterItemType(-1);
  public selectedSkillType: def.CharacterSkillType = new def.CharacterSkillType(-1);
  public selectedDelayEffect: api.DelayEffect = new api.DelayEffect(-1);
  public selectedTownSubBuilding: def.TownSubBuildingType = new def.TownSubBuildingType(-1);
  public commandCommentMessage: string = '';
  public temporaryAccount: api.Account = new api.Account(-1);

  public callCountryChatFocus?: EventObject;
  public callPrivateChatFocus?: EventObject;
  public imageUrl: string = '';

  public get isOpenDialog(): boolean {
    return this.isOpenSoldierDialog || this.isOpenTownCharactersDialog
      || this.isOpenTownDefendersDialog || this.isOpenCountryCharactersDialog
      || this.isOpenAllianceDialog || this.isOpenWarDialog || this.isOpenUnitsDialog
      || this.isOpenBattleLogDialog || this.isOpenPromotionDialog
      || this.isOpenCommandersDialog || this.isOpenRiceDialog || this.isOpenTownWarDialog
      || this.isOpenOppositionCharactersDialog || this.isOpenSafeDialog || this.isOpenSafeOutDialog
      || this.isOpenSecretaryDialog || this.isOpenAddSecretaryDialog
      || this.isOpenRemoveSecretaryDialog || this.isOpenCharacterIconPickerDialog || this.isOpenPoliciesDialog
      || this.isOpenSecretaryTownDialog || this.isOpenFormationDialog || this.isOpenFormationAddDialog
      || this.isOpenFormationChangeDialog || this.isOpenCharacterItemHandOverDialog || this.isOpenCharacterItemDialog
      || this.isOpenCharacterItemBuyDialog || this.isOpenCharacterItemSellDialog || this.isOpenSkillDialog
      || this.isOpenCharacterItemUseDialog || this.isOpenGenerateItemUseDialog || this.isOpenCommandCommentDialog
      || this.isOpenMapDialog || this.isOpenWelcomeDialog || this.isOpenBuildTownSubBuildingDialog
      || this.isOpenRemoveTownSubBuildingDialog || this.isOpenImage || this.isOpenCustomizeFlyingColumnDialog
      || this.isOpenRemoveFlyingColumnDialog || this.isOpenQueueDialog || this.isOpenCreateTownDialog
      || this.isOpenCommanderTargetCharacterDialog;
  }

  public yesnoEvent: () => void = () => undefined;

  public openCommandDialog(event: string) {
    if (event === 'soldier') {
      this.setSelectedSoldierNumberType(this.selectedSoldierNumberType);
      this.soldierMode = 0;
      this.isOpenSoldierDialog = true;
    } else if (event === 'soldier-religion') {
      this.setSelectedSoldierNumberType(this.selectedSoldierNumberType);
      this.soldierMode = 1;
      this.isOpenSoldierDialog = true;
    } else if (event === 'promotion') {
      this.model.updateOppositionCharacters();
      this.promotionTarget.id = -1;
      this.promotionMessage = '';
      this.isOpenPromotionDialog = true;
    } else if (event === 'rice') {
      if (this.payRiceOrMoney < 0) {
        this.payRiceOrMoney = this.model.characterRiceBuyMax;
      }
      this.selectedRiceStatus = 0;
      this.isOpenRiceDialog = true;
    } else if (event === 'safe') {
      this.paySafeMoney = def.PAY_SAFE_MAX;
      this.isOpenSafeDialog = true;
    } else if (event === 'safe-out') {
      this.model.updateCharacterCountryCharacters();
      this.paySafeMoney = def.PAY_SAFE_MAX;
      this.paySafeTarget.id = -1;
      this.isOpenSafeOutDialog = true;
    } else if (event === 'secretary') {
      this.targetSecretary.id = -1;
      this.targetUnit.id = -1;
      this.model.unitModel.updateUnits();
      this.model.updateCharacterCountryCharacters();
      this.isOpenSecretaryDialog = true;
    } else if (event === 'secretary-add') {
      this.mapDialogSelectedTown = this.model.town;
      this.isOpenAddSecretaryDialog = true;
    } else if (event === 'secretary-remove') {
      this.targetSecretary.id = -1;
      this.model.unitModel.updateUnits();
      this.model.updateCharacterCountryCharacters();
      this.isOpenRemoveSecretaryDialog = true;
    } else if (event === 'secretary-town') {
      this.targetSecretary.id = -1;
      this.model.updateCharacterCountryCharacters();
      this.mapDialogMode = 2;
      this.mapDialogSelectedTown = this.model.town;
      this.isOpenSecretaryTownDialog = true;
    } else if (event === 'flyingcolumn-customize') {
      this.targetSecretary.id = -1;
      this.model.updateCharacterCountryCharacters();
      this.mapDialogMode = 7;
      this.mapDialogSelectedTown = this.model.town;
      this.isOpenCustomizeFlyingColumnDialog = true;
    } else if (event === 'flyingcolumn-remove') {
      this.targetSecretary.id = -1;
      this.model.updateCharacterCountryCharacters();
      this.isOpenRemoveFlyingColumnDialog = true;
    } else if (event === 'formation-add') {
      this.selectedFormationType = new def.FormationType(-1);
      this.isOpenFormationAddDialog = true;
    } else if (event === 'formation-change') {
      this.selectedFormationType = new def.FormationType(-1);
      this.isOpenFormationChangeDialog = true;
    } else if (event === 'item-buy') {
      this.selectedCharacterItemType = { type: new def.CharacterItemType(-1), id: -1 };
      this.isOpenCharacterItemBuyDialog = true;
    } else if (event === 'item-sell') {
      this.selectedCharacterItemType = { type: new def.CharacterItemType(-1), id: -1 };
      this.isOpenCharacterItemSellDialog = true;
    } else if (event === 'item-handover') {
      this.model.updateCharacterCountryCharacters();
      this.selectedCharacterItemType = { type: new def.CharacterItemType(-1), id: -1 };
      this.isOpenCharacterItemHandOverDialog = true;
    } else if (event === 'item-use') {
      this.selectedCharacterItemType = { type: new def.CharacterItemType(-1), id: -1 };
      this.isOpenCharacterItemUseDialog = true;
    } else if (event === 'item-generate') {
      this.selectedGenerateItemType = new def.CharacterItemType(-1);
      this.isOpenGenerateItemUseDialog = true;
    } else if (event === 'command-comment') {
      this.commandCommentMessage = '';
      this.isOpenCommandCommentDialog = true;
    } else if (event === 'town-move') {
      this.mapDialogMode = 0;
      this.mapDialogSelectedTown = this.model.town;
      this.isOpenMapDialog = true;
    } else if (event === 'town-buy') {
      this.mapDialogMode = 8;
      this.mapDialogSelectedTown = this.model.town;
      this.isOpenMapDialog = true;
    } else if (event === 'town-war') {
      this.mapDialogMode = 1;
      this.mapDialogSelectedTown = this.model.town;
      this.isOpenMapDialog = true;
    } else if (event === 'town-spy') {
      this.mapDialogMode = 5;
      this.mapDialogSelectedTown = this.model.town;
      this.isOpenMapDialog = true;
    } else if (event === 'subbuilding-build') {
      this.selectedTownSubBuilding = new def.TownSubBuildingType(-1);
      this.isOpenBuildTownSubBuildingDialog = true;
    } else if (event === 'subbuilding-remove') {
      this.selectedTownSubBuilding = new def.TownSubBuildingType(-1);
      this.isOpenRemoveTownSubBuildingDialog = true;
    } else if (event === 'queue') {
      this.isOpenQueueDialog = true;
    } else if (event === 'town-create') {
      this.isOpenCreateTownDialog = true;
    }
  }

  public closeDialogs() {
    this.isOpenSoldierDialog = this.isOpenTownCharactersDialog =
      this.isOpenTownDefendersDialog = this.isOpenCountryCharactersDialog =
      this.isOpenAllianceDialog = this.isOpenWarDialog = this.isOpenUnitsDialog =
      this.isOpenBattleLogDialog = this.isOpenPromotionDialog =
      this.isOpenCommandersDialog = this.isOpenRiceDialog = this.isOpenTownWarDialog =
      this.isOpenOppositionCharactersDialog = this.isOpenSafeDialog = this.isOpenSafeOutDialog =
      this.isOpenSecretaryDialog = this.isOpenAddSecretaryDialog =
      this.isOpenRemoveSecretaryDialog = this.isOpenCharacterIconPickerDialog = this.isOpenPoliciesDialog =
      this.isOpenSecretaryTownDialog = this.isOpenFormationDialog = this.isOpenFormationAddDialog =
      this.isOpenFormationChangeDialog = this.isOpenCharacterItemHandOverDialog =
      this.isOpenCharacterItemDialog = this.isOpenCharacterItemBuyDialog = this.isOpenCharacterItemSellDialog =
      this.isOpenSkillDialog = this.isOpenCharacterItemUseDialog = this.isOpenGenerateItemUseDialog =
      this.isOpenCommandCommentDialog = this.isOpenMapDialog = this.isOpenWelcomeDialog =
      this.isOpenBuildTownSubBuildingDialog = this.isOpenRemoveTownSubBuildingDialog = this.isOpenImage =
      this.isOpenCustomizeFlyingColumnDialog = this.isOpenRemoveFlyingColumnDialog = this.isOpenQueueDialog =
      this.isOpenCreateTownDialog = this.isOpenCommanderTargetCharacterDialog = false;
  }

  public closeMapDialog() {
    if (this.mapDialogMode === 0) {
      this.model.commands.inputer.inputMoveCommand(17, this.mapDialogSelectedTown.id);
    } else if (this.mapDialogMode === 1) {
      this.model.commands.inputer.inputBattleCommand(13, this.mapDialogSelectedTown.id, this.isMoveIfFailed);
    } else if (this.mapDialogMode === 2) {
      this.model.commands.inputer.inputSecretaryMoveCommand(47, this.targetSecretary.id, this.mapDialogSelectedTown.id);
    } else if (this.mapDialogMode === 5) {
      this.model.commands.inputer.inputMoveCommand(61, this.mapDialogSelectedTown.id);
    } else if (this.mapDialogMode === 6) {
      this.model.giveTownToCountry(this.mapDialogSelectedTown.id);
    } else if (this.mapDialogMode === 7) {
      this.model.commands.inputer.inputCustomizeFlyingColumnCommand(67, this.targetSecretary.id,
        this.flyingColumnAction, this.mapDialogSelectedTown.id, this.flyingColumnSoldierType);
    } else if (this.mapDialogMode === 8) {
      this.model.commands.inputer.inputMoveCommand(74, this.mapDialogSelectedTown.id);
    }
    this.isOpenMapDialog = false;
  }

  public get chatObj(): IChatMessageContainer | undefined {
    if (this.selectedActionTab === 1) {
      if (this.selectedChatCategory === 0) {
        return this.model.countryChat;
      } else if (this.selectedChatCategory === 1) {
        return this.model.privateChat;
      } else if (this.selectedChatCategory === 5) {
        return this.model.globalChat;
      } else if (this.selectedChatCategory === 6) {
        return this.model.global2Chat;
      }
    }
    return undefined;
  }

  @Watch('selectedChatCategory')
  @Watch('selectedActionTab')
  @Watch('selectedActionTabSubPanel')
  public onChatTabChanged() {
    this.model.countryChat.isOpen =
      this.model.privateChat.isOpen =
      this.model.globalChat.isOpen =
      this.model.global2Chat.isOpen =
      this.model.promotions.isOpen =
      this.model.countryThreadBbs.isOpen =
      this.model.globalThreadBbs.isOpen =
      this.model.isOpenIssueBbs = false;
    if (this.selectedActionTab === 1) {
      const obj = this.chatObj;
      if (obj) {
        obj.isOpen = true;
      }
    } else if (this.selectedActionTab === 3) {
      if (this.selectedActionTabSubPanel === 0) {
        this.model.promotions.isOpen = true;
      } else if (this.selectedActionTabSubPanel === 2) {
        this.model.globalThreadBbs.isOpen = true;
      } else if (this.selectedActionTabSubPanel === 9) {
        this.model.isOpenIssueBbs = true;
        this.model.isIssueBbsUnread = false;
      }
    } else if (this.selectedActionTab === 2) {
      this.model.countryThreadBbs.isOpen = true;
    }
  }

  public getPolicyPoint(type: def.CountryPolicyType): number {
    const policy = Enumerable
      .from(this.model.store.policies)
      .firstOrDefault((p) => p.type === type.id && p.countryId === this.model.character.countryId);
    if (policy) {
      return policy.status === api.CountryPolicy.statusBoosted ? type.point / 2 : type.point;
    } else {
      return type.point;
    }
  }

  public mounted() {
    this.model.onCreate(() => this.$router);
    if (this.$route.query.first) {
      this.isOpenWelcomeDialog = true;
    }
    if (this.$route.query.app) {
      (window as any).sangokukmy_app = this.$route.query.app;
    }
    if ((window as any).sangokukmy_app) {
      this.isApp = true;
    }
  }

  public destroyed() {
    this.model.onDestroy();
  }

  public showMap() {
    if (this.mapShowType === 0 || this.mapShowType === 3) {
      return;
    }
    this.mapShowType = 0;
  }

  private readyPrivateChat(chara: api.Character) {
    this.model.privateChat.sendTo = chara;
    this.selectedActionTab = 1;
    this.selectedChatCategory = 1;
    if (this.callPrivateChatFocus) {
      this.callPrivateChatFocus.fire();
    }
  }

  private readyPrivateChatById(id: number) {
    const chara = Enumerable
      .from(this.model.store.characters)
      .firstOrDefault((c) => c.id === id);
    if (chara) {
      this.readyPrivateChat(chara);
    }
  }

  private readyOtherCountryChat(country: api.Country) {
    this.model.countryChat.sendTo = country;
    this.selectedActionTab = 1;
    this.selectedChatCategory = 0;
    if (this.callCountryChatFocus) {
      this.callCountryChatFocus.fire();
    }
  }

  private readyOtherCountryChatById(id: number) {
    const country = Enumerable.from(this.model.countries)
      .firstOrDefault((c) => c.id === id);
    if (country) {
      this.readyOtherCountryChat(country);
    }
  }

  private onMapDialogSelected(townId: number) {
    const town = this.model.towns.find((t) => t.id === townId);
    if (town) {
      this.mapDialogSelectedTown = town;
    }
  }

  private onMapLogScrolled(event: any) {
    if (this.isScrolled(event)) {
      this.model.loadOldMapLogs();
    }
  }

  private onCharacterLogScrolled(event: any) {
    if (this.isScrolled(event)) {
      this.model.loadOldCharacterLogs();
    }
  }

  private readyEditCommanders() {
    this.isOpenCommandersDialog = false;
    this.selectedActionTab = 3;
    this.selectedActionTabSubPanel = 1;
    if (typeof(this.$refs.commandersMessageInput) === 'object') {
      if (Array.isArray(this.$refs.commandersMessageInput)) {
        (this.$refs.commandersMessageInput[0] as HTMLTextAreaElement).focus();
      } else {
        (this.$refs.commandersMessageInput as HTMLTextAreaElement).focus();
      }
    }
  }

  private isScrolled(event: any): boolean {
    // スクロールの現在位置 + 親（.item-container）の高さ >= スクロール内のコンテンツの高さ
    return (event.target.scrollTop + 50 + event.target.offsetHeight) >= event.target.scrollHeight;
  }

  private resetNewIcon() {
    this.newIcon = new api.CharacterIcon(0, 0, false, 1, '0.gif');
  }

  private resetTargetCharacter() {
    this.targetCharacter = new api.Character(0);
  }

  private setSelectedSoldierNumberType(num: number) {
    this.selectedSoldierNumberType = num;
    if (num === 0) {
      this.soldierNumber = this.model.character.leadership;
    } else if (num === 1) {
      this.soldierNumber = 1;
    } else if (num === 2) {
      this.soldierNumber = 9;
    } else if (num === 3) {
      if (this.model.character.leadership % 10 === 9) {
        this.soldierNumber = this.model.character.leadership;
      } else {
        this.soldierNumber = Math.floor(this.model.character.leadership / 10) * 10 - 10 + 9;
      }
    }
  }

  private openImage(event: any) {
    this.imageUrl = event;
    this.isOpenImage = true;
  }

  private openIssueLink(id: number) {
    this.selectedActionTab = 3;
    this.selectedActionTabSubPanel = 9;
    (this.$refs.bbs as any).openIssue(id);
  }

  private openYesno(event: any) {
    this.yesnoMessage = event.message;
    this.yesnoEvent = event.onYes;
    this.isYesno = true;
  }

  private reloadPage() {
    window.location.href = '/status?app=ios';
  }
}
